import { ANSOKAN_ROUTING_NAMES } from '../ansokan/constants/ansokan.routes.names';
import { APP_ROUTING_NAMES } from '../app.routes.names';
import { IQuery } from './navigation-query/IQuery';

export class QueryGenerator {

    private get foreignUrl(): string {
        return 'https://www.skolverket.se/regler-och-ansvar/lararlegitimation-och-forskollararlegitimation'
            + '/lararlegitimation-och-forskollararlegitimation-med-utlandsk-examen/'
            + 'ansok-larar--och-forskollararlegitimation-utlandsk-examen#Ans%C3%B6kan%20med%20utl%C3%A4ndsk%20examen';
    }

    private get paperUrl(): string {
        return this.useNewPaper ? `${APP_ROUTING_NAMES.ANSOKAN_NO_LOGIN}/${ANSOKAN_ROUTING_NAMES.START}`
            : 'https://extproxy.skolverket.se/ansokan-nologin/lararlegitimation/ansokantyp';
    }

    constructor(private useNewDigital: boolean, private useNewPaper: boolean) { }

    public getQuery(): IQuery {
        return this.hasSwedishDegreeQuery();
    }

    private hasSwedishDegreeQuery(): IQuery {
        return {
            options: [
                {
                    link: null,
                    next: this.paperOrDigitalQuery(),
                    text: 'Ja',
                },
                {
                    link: null,
                    next: this.newOrComplementQuery(),
                    text: 'Nej',
                },
            ],
            query: 'Ansöker du om legitimation med en svensk examen?',
        };
    }

    private paperOrDigitalQuery(): IQuery {
        return {
            options: [
                {
                    link: {
                        description: 'Du som ansöker utan e-legitimation fyller i ansökan på webben och skriver sedan ut'
                            + ' den och skickar den per post tillsammans med kopior på dina intyg.'
                            + ' Förbered dig genom att att ta kopior på de intyg du kommer att behöva.',
                        label: 'Ansök utan digitalt ID',
                        url: this.paperUrl,
                    },
                    next: null,
                    text: 'Digital pappersansökan',
                },
            ],
            query: 'Vill du göra en digital pappersansökan?',
        };
    }

    private newOrComplementQuery(): IQuery {
        return {
            options: [
                {
                    link: {
                        description: null,
                        label: 'Ansök med utländsk examen',
                        url: this.foreignUrl,
                    },
                    next: null,
                    text: 'Ansökan om legitimation',
                },
                {
                    link: null,
                    next: this.paperOrDigitalQuery(),
                    text: 'Ansökan om komplettering av legitimation med ytterligare behörigheter',
                },
            ],
            query: 'Gäller din ansökan om legitimation eller komplettering av legitimation med ytterligare behörigheter?',
        };
    }
}
